import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from "react";
import { ResponsivePicture } from "../../../Shared/components/Image";
import { VideoComponent } from "../../../Shared/components/Video/VideoComponent";
import { slugify } from "../../../Shared/utils/string";
import { Link } from "./library/link";
export const Teasers = (p)=>/*#__PURE__*/ _jsx("ul", {
        className: "teasers row",
        children: p.items.map((i, k)=>/*#__PURE__*/ _createElement(Teaser, {
                ...i,
                key: i.key || `teaser-${k}`
            }))
    });
export const Teaser = (p)=>/*#__PURE__*/ _jsx("li", {
        className: `teaser teaser--default ${p.imageUrl ? 'teaser--image' : 'teaser--text'} ${p.extraClasses ? p.extraClasses : "col-xs-12 col-sm-6 col-md-4"}`,
        children: TeaserInner({
            linkUrl: p.linkUrl,
            teaserContent: TeaserContent(p),
            title: p.title,
            categories: p.categories
        })
    });
export const TeaserInner = (p)=>/*#__PURE__*/ _jsx(Link, {
        url: p.linkUrl,
        className: "teaser__link",
        "aria-labelledby": `a11y-teaser-title-${slugify(p.title)}`,
        children: p.teaserContent
    });
export const TeaserContent = (p)=>{
    const { video, headingLevel: Heading } = p;
    return /*#__PURE__*/ _jsx("article", {
        className: `teaser__inner${p.label ? ' has-label' : ''}${p.video ? ' has-video' : ''}`,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "teaser__content",
            children: [
                p.label && /*#__PURE__*/ _jsx("div", {
                    className: "teaser__meta",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "teaser__label",
                        children: p.label
                    })
                }),
                /*#__PURE__*/ _jsxs("header", {
                    className: "teaser__header",
                    children: [
                        /*#__PURE__*/ _jsx(Heading, {
                            className: "teaser__title",
                            id: `a11y-teaser-title-${slugify(p.title)}`,
                            children: /*#__PURE__*/ _jsx("span", {
                                dangerouslySetInnerHTML: {
                                    __html: p.title
                                }
                            })
                        }),
                        p.isTip && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "teaser__tip",
                                    children: "Tip"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "sr-text",
                                    children: " van de redactie"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "teaser__text",
                    children: [
                        p.intro && /*#__PURE__*/ _jsx("p", {
                            className: "teaser__intro",
                            dangerouslySetInnerHTML: {
                                __html: p.intro
                            }
                        }),
                        p.locationFooter && /*#__PURE__*/ _jsxs("footer", {
                            className: "teaser__footer text--xs",
                            children: [
                                /*#__PURE__*/ _jsx("svg", {
                                    className: "teaser__footer-icon",
                                    width: "20px",
                                    height: "24px",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ _jsx("use", {
                                        xlinkHref: "#icon--pin-dnb"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "sr-text",
                                    children: "Locatie: "
                                }),
                                p.locationFooter
                            ]
                        }),
                        p.footer && /*#__PURE__*/ _jsx("footer", {
                            className: "teaser__footer",
                            children: p.footer
                        })
                    ]
                }),
                p.categories && /*#__PURE__*/ _jsx("div", {
                    className: "teaser__tags tags",
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "tags__list",
                        children: p.categories.map((category)=>/*#__PURE__*/ _jsx("li", {
                                className: "tags__item",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "tags__tag",
                                    children: category.name
                                })
                            }, `blog_posts_category_item_${category.slug}`))
                    })
                }),
                p.imageUrl && /*#__PURE__*/ _jsx(TeaserVisual, {
                    ...p
                }),
                video && /*#__PURE__*/ _jsx("div", {
                    className: "video-block__wrapper teaser__video",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "video-block__inner",
                        children: /*#__PURE__*/ _jsx(VideoComponent, {
                            video,
                            showAcceptCookiesButton: false
                        })
                    })
                })
            ]
        })
    });
};
export const TeaserHasLinkContent = (p)=>{
    const Heading = p.headingLevel;
    return /*#__PURE__*/ _jsxs("article", {
        className: "teaser__inner",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "teaser__content",
                children: [
                    /*#__PURE__*/ _jsx("header", {
                        className: "teaser__header",
                        children: /*#__PURE__*/ _jsx(Heading, {
                            className: "teaser__title",
                            id: `a11y-teaser-title-${slugify(p.title)}`,
                            children: /*#__PURE__*/ _jsx("span", {
                                dangerouslySetInnerHTML: {
                                    __html: p.title
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "teaser__text",
                        children: [
                            (p.capacity || p.price) && /*#__PURE__*/ _jsxs("div", {
                                className: "teaser__data text--xs",
                                children: [
                                    p.capacity && /*#__PURE__*/ _jsxs("div", {
                                        className: "teaser__dataitem",
                                        children: [
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "teaser__datalabel",
                                                children: [
                                                    p.capacity,
                                                    " pers."
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("svg", {
                                                className: "teaser__dataicon",
                                                width: "20px",
                                                height: "19px",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ _jsx("use", {
                                                    xlinkHref: "#icon--capacity-zv"
                                                })
                                            })
                                        ]
                                    }),
                                    p.price && /*#__PURE__*/ _jsxs("div", {
                                        className: "teaser__dataitem",
                                        children: [
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "teaser__datalabel",
                                                children: [
                                                    "€ ",
                                                    p.price
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("svg", {
                                                className: "teaser__dataicon",
                                                width: "21px",
                                                height: "20px",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ _jsx("use", {
                                                    xlinkHref: "#icon--price"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            p.intro && /*#__PURE__*/ _jsx("div", {
                                className: "teaser__intro",
                                dangerouslySetInnerHTML: {
                                    __html: p.intro
                                }
                            }),
                            p.footer && /*#__PURE__*/ _jsx("footer", {
                                className: "teaser__footer text--xs",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "link link--primary link--arrow",
                                    children: p.footer
                                })
                            })
                        ]
                    })
                ]
            }),
            p.imageUrl && /*#__PURE__*/ _jsx(TeaserVisual, {
                ...p
            })
        ]
    });
};
export const SliderTeaserContent = (p)=>{
    const { video, headingLevel: Title } = p;
    return /*#__PURE__*/ _jsx("article", {
        className: `teaser__inner${p.label ? ' has-label' : ''}${video ? ' has-video' : ''}`,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "teaser__content",
            children: [
                p.label && /*#__PURE__*/ _jsx("div", {
                    className: "teaser__meta",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "teaser__label",
                        children: p.label
                    })
                }),
                /*#__PURE__*/ _jsx("header", {
                    className: "teaser__header",
                    children: /*#__PURE__*/ _jsxs(Title, {
                        className: "teaser__title",
                        children: [
                            p.isTip && /*#__PURE__*/ _jsx("span", {
                                className: "teaser__tip",
                                children: "TIP"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: p.title
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "teaser__text",
                    children: [
                        p.intro && /*#__PURE__*/ _jsx("p", {
                            className: "teaser__intro",
                            dangerouslySetInnerHTML: {
                                __html: p.intro
                            }
                        }),
                        p.locationFooter && /*#__PURE__*/ _jsxs("footer", {
                            className: "teaser__footer text--xs",
                            children: [
                                /*#__PURE__*/ _jsx("svg", {
                                    className: "teaser__footer-icon",
                                    width: "20px",
                                    height: "24px",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ _jsx("use", {
                                        xlinkHref: "#icon--pin-dnb"
                                    })
                                }),
                                p.locationFooter
                            ]
                        })
                    ]
                }),
                p.imageUrl && /*#__PURE__*/ _jsx(TeaserVisual, {
                    ...p
                }),
                video && /*#__PURE__*/ _jsx("div", {
                    className: "video-block__wrapper teaser__video",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "video-block__inner",
                        children: /*#__PURE__*/ _jsx(VideoComponent, {
                            video,
                            showAcceptCookiesButton: false
                        })
                    })
                })
            ]
        })
    });
};
export const SliderTeaser = (p)=>/*#__PURE__*/ _jsx("div", {
        className: "teaser teaser--default teaser--image teaser--carousel",
        children: TeaserInner({
            linkUrl: p.linkUrl,
            teaserContent: SliderTeaserContent(p),
            title: p.title
        })
    });
const TeaserVisual = (p)=>/*#__PURE__*/ _jsxs("div", {
        className: "teaser__visual",
        children: [
            /*#__PURE__*/ _jsx(ResponsivePicture, {
                imgClassName: "teaser__image",
                defaultImageUrl: p.imageUrlFallback,
                cropsPerMedia: [
                    {
                        crops: [
                            {
                                url: p.imageUrl,
                                width: 420
                            },
                            {
                                url: p.imageUrlLarge,
                                width: 840
                            }
                        ]
                    }
                ],
                width: 420,
                height: 320,
                alt: p.imageAlt
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "teaser__hover",
                "aria-hidden": "true"
            })
        ]
    });
{}